export const GLOBAL_TRANSLATIONS = {
  AMICA:
    'Amica{includeFullName, select, true { {showLife, select, true {Life} other {Mutual}} Insurance Company} other {}}',
  AMICA_LOGO: 'Amica Logo',
  LOGIN: 'Login',
  PASSWORD: 'Password',
  WERE_SORRY: "We're sorry",
  WERE_SORRY_EXCLAMATION: "We're sorry!",
  PLEASE_TRY_AGAIN: 'Please try again',
  TRY_AGAIN: 'Try Again',
  PLEASE_CALL_TO_CONTINUE: 'Please give us a call to continue',
  HERE: 'here',
  HOW_IT_WORKS: 'How it works',
  EMAIL: 'Email',
  EMAIL_ADDRESS: 'Email Address',
  PHONE: 'Phone',
  PHONE_NUMBER: 'Phone Number',
  PHONE_EXTENSION: 'Extension',
  PHONE_TYPE: 'Phone Type',
  CELL_PHONE_NUMBER: 'Cell Phone Number',
  MOBILE_PHONE_NUMBER: 'Mobile Phone Number',
  ADD_PHONE_NUMBER: 'Add Phone Number',
  NEW_PHONE_NUMBER: 'New Phone Number',
  NEW_MOBILE_PHONE_NUMBER: 'New Mobile Phone Number',
  TEXT_MESSAGE: 'Text Message',
  GOOGLE_AUTHENTICATOR: 'Google Authenticator',
  CREATE_AN_ACCOUNT: 'Create an account',
  PRIVACY_POLICY: 'Privacy Policy',
  ONLINE_TERMS_OF_USE: 'Online Terms of Use',
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  REVIEW_PRIVACY_POLICY: 'Review our Privacy Policy',
  ENROLL: 'Enroll',
  EDIT: 'Edit',
  EDIT_COVERAGE: 'Edit Coverage',
  EDIT_MY_INFO: 'Edit my information',
  CANCEL: 'Cancel',
  VERIFY: 'Verify',
  CLOSE: 'Close',
  BACK: 'Back',
  REFRESH: 'Refresh',
  CONTINUE: 'Continue',
  CONTINUE_WITH_LOB: 'Continue with {lobType} Quote',
  NEXT: 'Next',
  OK: 'Ok',
  SUBMITTING: 'Submitting...',
  LOADING: 'Loading...',
  SAVE_CHANGES: 'Save Changes',
  NAME: 'Name',
  SALUTATION: 'Salutation',
  LAST_NAME: 'Last Name',
  FIRST_NAME: 'First Name',
  MIDDLE_INITIAL: 'Middle Initial',
  MIDDLE_INITIAL_ABBREVIATED: 'MI',
  SUFFIX: 'Suffix',
  DATE: 'Date',
  DATE_OF_BIRTH: 'Date of Birth',
  ACCOUNT: 'Account',
  BILLING: 'Billing',
  DOCUMENTS: 'Documents',
  POLICIES: 'Policies',
  SELECT_A_POLICY: 'Select a Policy',
  NOTIFICATIONS: 'Notifications',
  CLAIMS: 'Claims',
  PROFILE: 'Profile',
  LOG_IN: 'Log In',
  LOG_OUT: 'Log Out',
  SUBMIT: 'Submit',
  SEND: 'Send',
  SET_UP: 'Set Up',
  SECURITY: 'Security',
  MULTIFACTOR_AUTHENTICATION: 'Multi-Factor Authentication',
  NEED_HELP: 'Need Help?',
  SCREEN_READER_LOADING: 'Loading',
  SCREEN_READER_LOADING_COMPLETE: 'Loading complete',
  BACK_TO_TOP: 'Back to Top',
  BACK_TO_ADC: 'Back to Amica.com',
  ADC_LINK_TEXT: 'Amica.com',
  BACK_TO_OVERVIEW: 'Back to Overview',
  GO_TO_ACCOUNT_HOME: 'Go to Account Home',
  EXIT_ARE_YOU_SURE: 'Are you sure you want to exit?',
  PRINT: 'Print',
  MONTH: 'Month',
  MONTHS: 'Months',
  MONTH_PLACEHOLDER: 'MM',
  QR_CODE_HEADER: 'Mobile app QR code',
  AMICA_MOBILE_APP: 'Amica Mobile App',
  YEAR: 'Year',
  YEARS: 'Years',
  YEAR_PLACEHOLDER: 'YYYY',
  STATUS: 'Status',
  MARITAL_STATUS: 'Marital Status',
  GENDER: 'Gender',
  DRIVER_DISCOUNTS: 'Driver Discounts',
  MORE_WAYS_TO_SAVE: 'More Ways to Save',
  LICENSE_STATE: 'License State',
  TOTAL: 'Total{colon, select, true {:} other {}}{trailingSpace, select, true { } other {}}',
  POLICY: 'Policy',
  POLICY_PERIOD: 'Policy Period{colon, select, true {:} other {}}{trailingSpace, select, true { } other {}}',
  POLICY_PERIOD_BOLD: '<b>Policy Period:</b> {policyPeriod}',
  GO_PAPERLESS: 'Go Paperless',
  NAVIGATION_LANDMARK_ARIA_LABEL: 'Navigation',
  HEADER_LANDMARK_ARIA_LABEL: 'Page header',
  MAIN_LANDMARK_ARIA_LABEL: 'Main content',
  FOOTER_LANDMARK_ARIA_LABEL: 'Page footer',
  DOLLAR_SIGN_SYMBOL: '$',
  REMOVE: 'Remove',
  CONTACT_INFO: 'Contact Info',
  CONTACT_INFORMATION: 'Contact Information',
  CONTACT_INFORMATION_SUBTEXT:
    "Provide us with your contact information and we'll reach out about your quote and email you a copy.",
  ID_CARDS: 'ID Cards',
  EMAIL_ID_CARDS: 'Email ID Cards',
  PAY_AS_GUEST: 'Pay as Guest',
  THANK_YOU: 'Thank you!',
  I_UNDERSTAND: 'I Understand',
  OPTIONAL: 'Optional',
  YES: 'Yes',
  NO: 'No',
  CONTACT_US: 'Contact Us',
  PRIVACY_AND_SECURITY: 'Privacy and Security',
  UPLOAD: 'Upload',
  CALL: 'Call',
  UPLOADING: 'Uploading',
  LIMIT: 'Limit',
  SECURITY_CODE: 'Security Code',
  ACCOUNT_NUMBER: 'Account Number',
  ZIP_CODE: 'ZIP code',
  LIFE_POLICIES: 'Life Policies',
  LIFE: 'Life',
  EXIT: 'Exit',
  MANAGE: 'Manage',
  ADD: 'Add',
  ADD_ITEM: 'Add Item',
  VALUE: 'Value',
  HIDE: 'Hide',
  SHOW: 'Show',
  HIDE_THIS: 'Hide This',
  MANAGE_NOTIFICATIONS: 'Manage Notifications',
  SUCCESS: 'Success!',
  VIEW_POLICY: 'View {isRenewal, select, true {Renewal} other {Policy}}',
  OTHER: 'Other',
  STATE: 'State',
  RETURN_TO_HOMEPAGE: 'Return to Amica homepage',
  LEARN_MORE: 'Learn More',
  START: 'Start',
  SKIP: 'Skip',
  HOME: 'Home',
  AUTO: 'Auto',
  VIN: 'VIN',
  ACCOUNT_NO: 'Account no. {accountNumber}'
};

export const GLOBAL_ERRORS = {
  PAGE_ERROR_DEFAULT:
    "We're sorry, something went wrong. {includeRefresh, select, true {Please refresh to try again or contact us at {contactPhone} for further assistance.} other {}}",
  TECHNICAL_SUBMISSION_ERROR: 'You can attempt to resubmit your change, try again later or call us at {contactPhone}.',
  SYSTEM_ERROR: 'We apologize, but our system is temporarily unable to handle your request.',
  PLEASE_CALL_FOR_ASSISTANCE: 'Please call us at {contactPhone} for assistance.',
  GENERAL_API_ERROR_HEADER: "We're sorry! Something went wrong on our end.",
  GENERAL_API_ERROR_MESSAGE: "We're unable to handle your request at this time. Please try again later.",
  PARTY_ERROR_HEADER: 'Error loading your information',
  PARTY_ERROR_SUBTEXT: 'We were unable to retrieve your account information. Please refresh the page.',
  MOBILE_APP_PARTY_ERROR_HEADER: 'Loading Error',
  MOBILE_APP_PARTY_ERROR_SUBTEXT:
    'We were unable to retrieve your account information.{br}{br}Please close the app and try again.',
  BILLING_PAYMENT_API_ERROR_SUBTEXT:
    "We're sorry, something went wrong on our end. Please try resubmitting or give us a call at {contactPhone} to make your payment over the phone.",
  MFA_ERROR_INVALID_CODE: 'This code is invalid',
  WERE_HAVING_A_TECHNICAL_PROBLEM: "Sorry, we're having a technical problem.",
  SORRY_NEED_TO_FIX: 'Sorry, we need you to fix something',
  CALL_TO_CONTINUE_QUOTE:
    "Based on the information you provided, we'd like to discuss the insurance options that are available to you. Please call us at {phoneLink} to speak with a representative and continue your quote."
};

export const GLOBAL_VALIDATIONS = {
  FORM_VALIDATION_ERROR_BANNER_HEADING: "We're sorry. We need a little more information.",
  FORM_VALIDATION_ERROR_BANNER_BODY: 'Please correct any errors and add missing details below.',
  MISSING_REQUIRED_FIELD: 'Missing required field',
  MISSING_REQUIRED_INPUT: 'Please provide a valid response',
  MISSING_REQUIRED_SELECTION: 'Please select a valid response',
  ENROLLED_PHONE_VALIDATION: 'This is your currently enrolled phone number.  Please choose another.',
  SELECT_A_PHONE_OR_ADD_NEW: 'Select a phone number{canAddNew, select, true { or add a new one} other {}}',
  TERMS_AND_CONDITIONS: 'Please agree to the Terms & Conditions',
  VALID_PHONE_VALIDATION: 'Please enter a valid 10-digit phone number',
  VALID_FIRST_NAME: 'Please enter a valid first name',
  VALID_LAST_NAME: 'Please enter a valid last name',
  VALID_DOB: 'Please enter a valid date of birth',
  VALID_EMAIL: 'Please enter a valid email',
  VALID_POLICY_NUMBER: 'Please enter a valid policy number',
  DUPLICATE_EMAIL: 'The email you entered is already in use',
  MFA_VALIDATION_ERROR:
    'Please enter the security code {isGoogleAuth, select, true {in your Google Authenticator app} other {that was sent to you}}',
  INVALID_MONTH: 'Please enter a valid month',
  INVALID_MAX_YEAR: 'Year must be less than or equal to {maxYear}',
  INVALID_MIN_YEAR: 'Date must be within last {years} years',
  INVALID_ZIP_CODE: 'Please enter a valid ZIP code'
};

export const GLOBAL_PHONE_NUMBERS = {
  CONTACT_PHONE_INTL: '+1-800-242-6422',
  CONTACT_PHONE_DISPLAY: '{withCall, select, true {Call } other {}}800\u2011242\u20116422',
  CONTACT_TEXT_NOTIFICATION_PHONE_INTL: '+1-833-915-0016',
  CONTACT_TEXT_NOTIFICATION_PHONE_DISPLAY: '833\u2011915\u20110016',
  CONTACT_LIFE_PHONE_DISPLAY: '800\u2011234\u20115433',
  CONTACT_LIFE_PHONE_INTL: '+1-800-234-5433',
  CONTACT_LIFE_CSR_PHONE_DISPLAY: '844\u2011894\u20114228',
  CONTACT_LIFE_CSR_PHONE_INTL: '+1-844-894-4228',
  CONTACT_LIFE_QUOTE_PHONE_DISPLAY: '{withCall, select, true {Call } other {}}833\u2011644\u20119850',
  CONTACT_LIFE_QUOTE_PHONE_INTL: '+1-833-644-9850',
  CONTACT_QUOTING_BUNDLE_DISPLAY: '{withCall, select, true {Call } other {}}833\u2011908\u20111522',
  CONTACT_QUOTING_BUNDLE_INTL: '+1-833-908-1522',
  CONTACT_QUOTE_PHONE_DISPLAY: '{withCall, select, true {Call } other {}}855\u2011862\u20113026',
  CONTACT_QUOTE_PHONE_INTL: '+1-855-862-3026'
};

export const GLOBAL_EMAIL_ADDRESSES = {
  LIFE_ADDRESS_EMAIL: 'LCService@amica.com'
};

export const GLOBAL_ADDRESS_FORM_FIELDS = {
  STREET_ADDRESS: 'Street Address',
  ADDRESS_LINE_1: 'Address Line 1',
  ADDRESS_LINE_2: 'Address Line 2',
  ADDRESS_UNIT_NUMBER: 'Apt/Unit Number',
  ADDRESS_CITY: 'City',
  ADDRESS_CITY_TOWN: 'City/Town',
  ADDRESS_STATE: 'State',
  ADDRESS_ZIP: 'ZIP code',
  ADDRESS_HINT_TEXT: 'Please do not use P.O. boxes'
};

export const GLOBAL_CALENDAR_VALUES = {
  DATE_WITH_SLASHES_HINT: 'MM/DD/YYYY',
  JANUARY: 'January',
  FEBRUARY: 'February',
  MARCH: 'March',
  APRIL: 'April',
  MAY: 'May',
  JUNE: 'June',
  JULY: 'July',
  AUGUST: 'August',
  SEPTEMBER: 'September',
  OCTOBER: 'October',
  NOVEMBER: 'November',
  DECEMBER: 'December',
  JANUARY_SHORT: 'Jan',
  FEBRUARY_SHORT: 'Feb',
  MARCH_SHORT: 'Mar',
  APRIL_SHORT: 'Apr',
  JUNE_SHORT: 'Jun',
  JULY_SHORT: 'Jul',
  AUGUST_SHORT: 'Aug',
  SEPTEMBER_SHORT: 'Sep',
  OCTOBER_SHORT: 'Oct',
  NOVEMBER_SHORT: 'Nov',
  DECEMBER_SHORT: 'Dec',
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday'
};
